import Vue from 'vue'
import VueRouter from 'vue-router'
import Simulation from '@/views/Simulation.vue'

import Register from '@/views/Register.vue'
import Overview from '@/views/Overview.vue'
import GettingStarted from '@/views/GettingStarted.vue'
import Action from '@/views/Action.vue'
// import Data from '@/views/Data.vue'
import InvestigationItem from '@/views/InvestigationItem.vue'
import GettingStartedInvestigationItem from '@/views/GettingStartedInvestigationItem.vue'
import ActionDecision from '@/views/ActionDecision.vue'
import ActionFeedback from '@/views/ActionFeedback.vue'
import Complete from '@/views/Complete.vue'

import store from '@/store/index.js'

Vue.use( VueRouter )

const routes = [
  {
    path: "/",
    name: "register",
    component: Register,
  },
  {
    path: "/overview",
    name: "overview",
    component: Overview,
  },
  {
    path: "/gettingstarted",
    name: "gettingstarted",
    component: GettingStarted,
  },
  {
    path: '/gettingstarted/investigate/:item',
    name: 'GettingStartedInvestigation',
    component: GettingStartedInvestigationItem
  },
  {
    path: '/sim',
    name: 'Simulation',
    redirect: to => store.getters.currentSlug
  },
  {
    path: '/sim/:action',
    name: 'Action',
    component: Action
  },
  {
    path: '/sim/:action/investigate/:item',
    name: 'Investigation',
    component: InvestigationItem
  },
  {
    path: '/sim/:action/decision',
    name: 'Decisions',
    component: ActionDecision
  },
  {
    path: '/sim/:action/feedback',
    name: 'Feedback',
    component: ActionFeedback
  },
  {
    path: "/complete",
    name: "complete",
    component: Complete,
  }
];

const router = new VueRouter({ routes })

// If someone refreshes, they start over... at register

router.beforeEach((to, from, next) => {
    if (to.name !== 'register' && store.getters.getEmail === '') {
        next({ name: 'register' })
    }
    else {
        next()
    }
})

export default router
